import request from '@/umi-request';
import { AxiosPromise } from 'axios';

import { CBU, CBUFile } from '@/interfaces/cbu';
import { PaginatedResponse } from '@/interfaces/response';
import { Note } from '@/interfaces/note';

export async function uploadCBU(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/cbu/`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data
  }) as AxiosPromise<CBUFile>;
}

export async function currentCBU(affiliate: number) {
  return request({
    url: `affiliates/${affiliate}/cbu/testCBU`,
    method: 'GET',
  }) as AxiosPromise<CBUFile>;
}

export async function uploadFileUpload(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/cbu/upload-file/`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data
  }) as AxiosPromise<CBU>;
}

export async function cancelCBU(affiliate: number, id: number) {
  return request(`affiliates/${affiliate}/cbu/${id}/cancel/`, {
    method: 'POST',
  }) as AxiosPromise<CBU>;
}

export function updateCBU(affiliate: number, id: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/cbu/${id}/update/`,
    method: 'PATCH',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data
  }) as AxiosPromise<CBU>;
}

export function endorseCBU(affiliate: number, id: number) {
  return request({
    url: `affiliates/${affiliate}/cbu/${id}/endorse/`,
    method: 'POST',
  }) as AxiosPromise<CBU>;
}

export async function queryCBUs(params: any = {}) {
  return request({
    url: 'cbu/',
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<CBU>>;
}

export function queryCBU(id: number | string) {
  return request({
    url: `cbu/${id}/`,
    method: 'GET',
  }) as AxiosPromise<CBU>;
}

export function updateCBUStatus(id: number | string, data: any) {
  return request({
    url: `cbu/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<CBU>;
}

export function queryCBUChangesHistory(id: number | string) {
  return request({
    url: `cbu/${id}/changes-history/`,
    method: 'GET',
  }) as AxiosPromise<CBU[]>;
}

export function queryCBUHistory(id: number | string) {
  return request({
    url: `cbu/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<CBU[]>;
}

export function sendCBUNote(id: number | string, data: { content: string }) {
  return request({
    url: `cbu/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<CBU>>;
}

export function getCBUNotes(id: number | string) {
  return request({
    url: `cbu/${id}/notes/`,
    method: 'GET',
  }) as AxiosPromise<Note<CBU>[]>;
}
